module.exports = __webpack_public_path__ + "static/media/kutiniHakobu.42444bf8.png";